import { defineCustomElement } from 'vue'
import ImageComposer from './components/ImageComposer.ce.vue'
import type { ResultData } from './composables/useOverlay'

// import { FONT_FACE_CSS } from '@/assets/fonts/sharedFonts'

// 1. Import the CSS as a raw string
import fontStyles from './assets/fonts.css?inline'
import tailwindStyles from './assets/main.css?inline'

// 1. Manually inject fonts into the main document head
const injectGlobalFonts = () => {
  if (document.getElementById('wmm-widget-fonts')) return
  const style = document.createElement('style')
  style.id = 'wmm-widget-fonts'
  style.textContent = fontStyles
  document.head.appendChild(style)
}

injectGlobalFonts()

ImageComposer.styles = [fontStyles, tailwindStyles, ...(ImageComposer.styles || [])]
const WmmWidget = defineCustomElement(ImageComposer)
const tagName = 'wmm-image-composer'
if (typeof window !== 'undefined' && !customElements.get(tagName)) {
  customElements.define(tagName, WmmWidget)
}

interface ImageComposerProps {
  results: ResultData
  btnLabel?: string
  mainText: string
  topPadding?: number
  bottomPadding?: number
}

function sortResultsByMostRecent(results: ResultData['results']) {
  const sorted = [...results].sort((a, b) => {
    return new Date(a.date).getTime() - new Date(b.date).getTime()
  })
  console.log('sorted', sorted)
  return sorted
}

export function mountImageComposer(selector: string, propsData: ResultData) {
  const host = document.querySelector(selector)

  if (host) {
    // Check if we already mounted here to prevent double-mounting
    if (host.querySelector(tagName)) {
      return
    }

    // 4. Use the ALREADY DEFINED constructor
    const el = new WmmWidget() as HTMLElement & ImageComposerProps

    // el.results = propsData
    el.results = {
      ...propsData,
      results: sortResultsByMostRecent(propsData.results),
    }
    el.btnLabel = host.getAttribute('data-btn-label') || 'Select image'
    el.mainText = host.getAttribute('data-main-text') || ''

    const tp = host.getAttribute('data-tp') || '0'
    el.topPadding = parseInt(tp, 10)

    const bp = host.getAttribute('data-bp') || '0'
    el.bottomPadding = parseInt(bp, 10)

    host.innerHTML = ''
    host.appendChild(el)

    console.log('WMM Extension: Successfully mounted component.', tp, bp)
  }
}

export { ImageComposer }
